// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected {
    box-shadow: 0px 0px 10px 7px var(--primary-color);
    background-color: #c6e067;
}
.drag-handler {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 20px;
    width: 20px;
    border-radius: 5px;
    background-color: gray;
    z-index: 999;
    display:none;
    cursor:move;
}

.drag-handler:hover {
    display:block;
}
.item:hover .drag-handler{
    display:block;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/layouts/raster/raster.layout.css"],"names":[],"mappings":"AAAA;IAGI,iDAAiD;IACjD,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB","sourcesContent":[".selected {\n    -webkit-box-shadow: 0px 0px 10px 7px var(--primary-color);\n    -moz-box-shadow: 0px 0px 10px 7px var(--primary-color);\n    box-shadow: 0px 0px 10px 7px var(--primary-color);\n    background-color: #c6e067;\n}\n.drag-handler {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    height: 20px;\n    width: 20px;\n    border-radius: 5px;\n    background-color: gray;\n    z-index: 999;\n    display:none;\n    cursor:move;\n}\n\n.drag-handler:hover {\n    display:block;\n}\n.item:hover .drag-handler{\n    display:block;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
